$(document).ready(function ($) {
  "use strict";

  function megaMenu() {

    if ($(".default_dropdown").length > 0) {

      /*
       * We intentionally do NOT set a fixed/full-row width
       * on .sub-menu-block here.
       *
       * The previous code was doing:
       *
       * .css("width", parentWidth)
       *
       * which made the invisible hover area much wider
       * than the visible dropdown.
       */

      $("#header .dt-nav li:not(.close-nav)").each(function () {

        var thisItem = $(this);

        if (thisItem.hasClass("menu-item-has-children")) {

          /*
           * Only target the FIRST-LEVEL submenu.
           *
           * Nested menus such as:
           *
           * Bracelet → Core Bracelet
           * Ring → Core Ring
           *
           * are NOT touched.
           */
          thisItem
            .children(".megamenu_megamenu")
            .children(".sub-menu-block")
            .css({
              "width": "auto",
              "min-width": "0"
            });

        }

      });


      /*
       * Sticky header menu
       *
       * Again, only the FIRST-LEVEL submenu is changed.
       */
      $("sticky-header .dt-nav li:not(.close-nav)").each(function () {

        var thisItem = $(this);

        if (thisItem.hasClass("menu-item-has-children")) {

          thisItem
            .children(".megamenu_megamenu")
            .children(".sub-menu-block")
            .css({
              "width": "auto",
              "min-width": "0"
            });

        }

      });


      /*
       * Let the theme recalculate its menu after loading.
       */
      window.setTimeout(function () {
        $(window).trigger("resize");
      }, 800);

    }

  }


  /*
   * Run menu setup.
   */
  var megaMenuResize = false;

  $(window).bind("resize", function () {

    if (!megaMenuResize) {

      megaMenu();

      megaMenuResize = true;

    }

  });

  megaMenu();

});


/*
 * Desktop / Mobile Tabs
 */
$(function () {

  if ($(window).width() >= 1200) {

    $(".deskTabs a").click(function () {

      let id = $(this).attr("href");

      $(".deskTabs li").removeClass("active");

      $(this).parent().addClass("active");

      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .addClass("active");

      $(".tabs-content li.dt-sc-menu-tabs").hide();

      $(this)
        .parent()
        .parent()
        .parent()
        .parent()
        .find(id)
        .show();

      return false;

    });

  }


  if ($(window).width() <= 1199) {

    $(".mobileTabs .tabs li").each(function () {

      $(this).click(function () {

        $(this)
          .next("div")
          .slideToggle(0);

      });

    });

  }

});


/*
 * Category Menu
 */
$(document).ready(function () {

  $("#category-menu-button").click(function () {

    $(this).toggleClass("open");

    $(".category-wrapper").toggleClass("open");

    $(".category-wrapper").slideToggle(0);

  });

});